  // ── ASTRAL FORGE · PACK OPENER ──────────────────────────
(function(){
  function boot(){
    var root = document.getElementById('afp'); if(!root) return;

    var ART = window.AFP_ART || {};
    var PACK_IMG = window.AFP_PACK || "";
    var BACK_IMG = window.AFP_BACK || "";

    /* roster: each Astral and the finishes it actually exists in */
    var ROSTER = {
      HUGO:["BASE","HOLO","GREEN_SPECKLE"], GAIA:["BASE","HOLO","PINK_SPECKLE","GOLD"],
      VIPER:["BASE","HOLO","GREEN_SPECKLE","COSMIC"], CALDHOP:["BASE","BLACK_SHADOW","GOLD"],
      GRAFF:["BASE","HOLO"], CRYOLITH:["BASE","HOLO","COSMIC"], PIGXEL:["BASE"],
      STEEF:["BASE","PINK_SPECKLE"], GELITH:["BASE","HOLO","GREEN_SPECKLE"], MUDDER:["BASE","BLACK_SHADOW"],
      HERNE:["BASE","BLACK_SHADOW"], SOLUN:["BASE","BLACK_SHADOW"],
      CORA:["BLACK_SHADOW","GOLD"], FLORA:["HOLO"], FROZERNE:["PINK_SPECKLE"],
      GLACIRRA:["HOLO","GREEN_SPECKLE","BLACK_SHADOW","COSMIC"], MAGMO:["HOLO"],
      NOD3R:["GREEN_SPECKLE","COSMIC"], PYRIX:["PINK_SPECKLE"], RYU:["PINK_SPECKLE"],
      SHIMP:["PINK_SPECKLE"], SHIM_BIT:["HOLO","GREEN_SPECKLE","GOLD"], SNOWLUN:["BLACK_SHADOW"],
      STEEFERNO:["HOLO","COSMIC","GOLD"], VIPERA:["GOLD"]
    };
    var DISPLAY = { SHIM_BIT:"Shim-bit", NOD3R:"Nod3r" };
    function nameOf(a){ return DISPLAY[a] || a.charAt(0)+a.slice(1).toLowerCase(); }
    var FIN = {
      BASE:{n:"Base",cls:"base",rare:false},
      HOLO:{n:"Holo",cls:"holo",rare:true},
      GREEN_SPECKLE:{n:"Green Speckle",cls:"green",rare:true},
      BLACK_SHADOW:{n:"Black Shadow",cls:"black",rare:true},
      PINK_SPECKLE:{n:"Pink Speckle",cls:"pink",rare:true},
      COSMIC:{n:"Cosmic",cls:"cosmic",rare:true},
      GOLD:{n:"Gold",cls:"gold",rare:true}
    };
    var FIN_ORDER = ["BASE","HOLO","GREEN_SPECKLE","BLACK_SHADOW","PINK_SPECKLE","COSMIC","GOLD"];
    var RARE_W = [["HOLO",40],["GREEN_SPECKLE",25],["BLACK_SHADOW",18],["PINK_SPECKLE",10],["COSMIC",5],["GOLD",2]];
    var BASE_ASTRALS = Object.keys(ROSTER).filter(function(a){return ROSTER[a].indexOf("BASE")>-1;});
    var BY_FINISH = {}; RARE_W.forEach(function(p){ BY_FINISH[p[0]] = Object.keys(ROSTER).filter(function(a){return ROSTER[a].indexOf(p[0])>-1;}); });
    var ALL=[]; Object.keys(ROSTER).sort().forEach(function(a){ ROSTER[a].slice().sort(function(x,y){return FIN_ORDER.indexOf(x)-FIN_ORDER.indexOf(y);}).forEach(function(f){ ALL.push(a+"_"+f); }); });
    var TOTAL = ALL.length;

    /* storage (per-browser) */
    var K_COLL="afp_coll_v2", K_DAY="afp_day_v2", K_BONUS="afp_bonus_v2";
    function load(k,d){ try{var v=localStorage.getItem(k);return v==null?d:JSON.parse(v);}catch(e){return d;} }
    function save(k,v){ try{localStorage.setItem(k,JSON.stringify(v));}catch(e){} }
    var coll = load(K_COLL,{});

    /* helpers */
    function rnd(n){return Math.floor(Math.random()*n);}
    function pick(a){return a[rnd(a.length)];}
    function key(a,f){return a+"_"+f;}
    function el(t,c,h){var e=document.createElement(t);if(c)e.className=c;if(h!=null)e.innerHTML=h;return e;}
    function byId(i){return document.getElementById(i);}

    function rollRareFinish(){
      var tot=0;RARE_W.forEach(function(p){tot+=p[1];});
      var r=Math.random()*tot;
      for(var i=0;i<RARE_W.length;i++){ r-=RARE_W[i][1]; if(r<=0) return RARE_W[i][0]; }
      return "HOLO";
    }
    function genPack(){
      var out=[];
      for(var i=0;i<4;i++) out.push({a:pick(BASE_ASTRALS),f:"BASE"});
      if(Math.random()<0.20){ var fin=rollRareFinish(); out.push({a:pick(BY_FINISH[fin]),f:fin}); }
      else out.push({a:pick(BASE_ASTRALS),f:"BASE"});
      return out;
    }

    /* daily limit + bonus */
    var DAY=86400000;
    function freeReady(){ var t=load(K_DAY,0); return (Date.now()-t)>=DAY; }
    function bonusAvailable(){ return window.__afpGrantBonus===true && load(K_BONUS,false)!==true; }
    function canOpen(){ return freeReady()||bonusAvailable(); }
    function consumeOpen(){ if(freeReady()) save(K_DAY,Date.now()); else if(bonusAvailable()) save(K_BONUS,true); }
    function msLeft(){ return Math.max(0, DAY-(Date.now()-load(K_DAY,0))); }
    function fmt(ms){ var s=Math.floor(ms/1000),h=Math.floor(s/3600),m=Math.floor((s%3600)/60); return h+"h "+m+"m"; }

    /* DOM refs */
    var stage=byId('afp-stage'), packImg=byId('afp-pack-img'), packBtn=byId('afp-pack'),
        statusEl=byId('afp-status'), grid=byId('afp-grid'), tally=byId('afp-tally'),
        feed=byId('afp-feed'), modal=byId('afp-modal');
    packImg.src=PACK_IMG;

    /* collection board */
    function renderColl(){
      grid.innerHTML="";
      ALL.forEach(function(k){
        var p=k.split("_"), fin=p.pop(); if(fin==="SPECKLE"||fin==="SHADOW"){ fin=p.pop()+"_"+fin; } var a=p.join("_");
        var owned=coll[k]>0;
        var cell=el('div','afp-slot '+FIN[fin].cls+(owned?' owned':' locked'));
        if(owned){
          cell.innerHTML='<img src="'+ART[k]+'" alt="'+nameOf(a)+' '+FIN[fin].n+'"/>'+(coll[k]>1?'<span class="afp-dup">x'+coll[k]+'</span>':'');
          cell.title=nameOf(a)+" · "+FIN[fin].n;
        } else {
          cell.innerHTML='<span class="afp-q">?</span>';
        }
        grid.appendChild(cell);
      });
      var uniq=Object.keys(coll).filter(function(k){return coll[k]>0;}).length;
      tally.textContent=uniq+" / "+TOTAL+" unique cards";
    }

    /* status / pack availability */
    var ticking=null;
    function refreshStatus(){
      if(ticking){clearInterval(ticking);ticking=null;}
      if(canOpen()){
        packBtn.classList.remove('afp-locked');
        statusEl.innerHTML = bonusAvailable() ? '<span class="afp-ready">✦ Bonus pack ready — tap to rip!</span>'
                                              : '<span class="afp-ready">Free pack ready — tap to rip</span>';
      } else {
        packBtn.classList.add('afp-locked');
        var used=load(K_BONUS,false)===true;
        function upd(){ statusEl.innerHTML='<span class="afp-cool">Next free pack in '+fmt(msLeft())+'</span>'+
          (used?'':' <button class="afp-unlock-btn" id="afp-unlock-btn">Unlock one more</button>'); 
          var b=byId('afp-unlock-btn'); if(b) b.onclick=openModal;
        }
        upd(); ticking=setInterval(upd,60000);
      }
    }

    /* feed (simulated, global names) */
    var NAMES=["Sofía","Mateo","Lucía","Diego","Lukas","Hannah","Jonas","Greta","Aarav","Priya","Rohan","Ananya",
      "Wei","Mei","Chen","Yan","Emir","Zeynep","Kenji","Yuki","Nadia","Omar","Freya","Tomás","Ingrid","Ravi","Lin","Sven"];
    var rareCards = ALL.filter(function(k){var f=k.replace(/^.*?_/,"");return FIN[k.slice(k.indexOf("_")+1)] && FIN[k.slice(k.indexOf("_")+1)].rare;});
    function splitKey(k){ var p=k.split("_"); var fin=p.pop(); if(fin==="SPECKLE"||fin==="SHADOW") fin=p.pop()+"_"+fin; return {a:p.join("_"),f:fin}; }
    function feedRow(name,k,mins){
      var s=splitKey(k);
      var li=el('li','afp-frow');
      li.innerHTML='<span class="afp-fwho">'+name+'</span> pulled a <span class="afp-fchip '+FIN[s.f].cls+'">'+FIN[s.f].n+'</span> '+nameOf(s.a)+
                   '<span class="afp-fago">'+(mins===0?'just now':mins+'m ago')+'</span>';
      return li;
    }
    function seedFeed(){
      feed.innerHTML="";
      for(var i=0;i<5;i++){ feed.appendChild(feedRow(pick(NAMES),pick(rareCards), 1+rnd(58))); }
    }
    function pushFeed(name,k,mins){
      feed.insertBefore(feedRow(name,k,mins),feed.firstChild);
      while(feed.children.length>6) feed.removeChild(feed.lastChild);
    }
    setInterval(function(){ pushFeed(pick(NAMES),pick(rareCards),0); },7000);

    /* build a single card element (face-down by default) */
    function cardEl(c){
      var k=key(c.a,c.f), f=FIN[c.f];
      var card=el('div','afp-card fin-'+f.cls+(f.rare?' is-rare':''));
      card.innerHTML =
        '<div class="afp-card-inner">'+
          '<div class="afp-face afp-back"><img src="'+BACK_IMG+'" alt="card back"/></div>'+
          '<div class="afp-face afp-front"><img src="'+ART[k]+'" alt="'+nameOf(c.a)+' '+f.n+'"/></div>'+
        '</div>';
      return card;
    }

    /* gold celebration */
    function goldBang(){
      var ov=el('div','afp-gold-bang'); root.appendChild(ov);
      root.classList.add('afp-shake');
      setTimeout(function(){ root.classList.remove('afp-shake'); },650);
      setTimeout(function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); },1100);
    }

    /* the stacked, click-to-advance reveal */
    function reveal(cards){
      stage.innerHTML="";
      var wrap=el('div','afp-reveal');
      var counter=el('div','afp-counter','Card 1 of 5');
      var deck=el('div','afp-deck');
      var hint=el('div','afp-hint','Tap the card to reveal');
      wrap.appendChild(counter); wrap.appendChild(deck); wrap.appendChild(hint);
      stage.appendChild(wrap);

      var nodes=[];
      for(var i=cards.length-1;i>=0;i--){ var n=cardEl(cards[i]); n.style.setProperty('--i',i); deck.appendChild(n); nodes[i]=n; }
      var idx=0, flipped=false;
      nodes[0].classList.add('active');

      function setHint(){
        var c=cards[idx], f=FIN[c.f];
        if(!flipped){ hint.textContent='Tap the card to reveal'; hint.className='afp-hint'; }
        else if(f.rare){ hint.textContent='✦ '+f.n+'! '+(idx<4?'Tap for the next card':'Your rare pull!'); hint.className='afp-hint rare '+f.cls; }
        else { hint.textContent=idx<4?'Tap for the next card':'Tap to finish'; hint.className='afp-hint'; }
      }
      function advance(){
        var card=nodes[idx], c=cards[idx], f=FIN[c.f];
        if(!flipped){
          flipped=true; card.classList.add('flip');
          if(f.cls==='gold') goldBang();
          else if(f.rare) card.classList.add('rare-pop');
          setHint();
          return;
        }
        card.classList.add('gone');
        idx++;
        if(idx>=cards.length){ setTimeout(function(){ summary(cards); },420); return; }
        flipped=false;
        counter.textContent='Card '+(idx+1)+' of 5';
        nodes[idx].classList.add('active');
        setHint();
      }
      deck.addEventListener('click',advance);
      deck.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();advance();} });
      setHint();
    }

    function summary(cards){
      /* record to collection */
      var best=null, bestRank=-1;
      cards.forEach(function(c){
        var k=key(c.a,c.f); coll[k]=(coll[k]||0)+1;
        var r=FIN_ORDER.indexOf(c.f); if(FIN[c.f].rare && r>bestRank){bestRank=r;best=c;}
      });
      save(K_COLL,coll); renderColl();
      if(best){ pushFeed('You',key(best.a,best.f),0); }

      stage.innerHTML="";
      var wrap=el('div','afp-summary');
      var fan=el('div','afp-fan');
      cards.forEach(function(c){
        var n=cardEl(c); n.classList.add('flip'); fan.appendChild(n);
      });
      var line = best ? '<span class="afp-res-rare '+FIN[best.f].cls+'">'+FIN[best.f].n+' '+nameOf(best.a)+'!</span>'
                      : '<span class="afp-res-base">Five solid bases — go again tomorrow.</span>';
      var res=el('div','afp-result',line);
      var again=el('button','afp-again', canOpen()? '⚡ Rip another' : 'Done');
      again.onclick=function(){ resetIdle(); };
      wrap.appendChild(fan); wrap.appendChild(res); wrap.appendChild(again);
      stage.appendChild(wrap);
    }

    function resetIdle(){
      stage.innerHTML =
        '<div class="afp-idle" id="afp-idle">'+
          '<div class="afp-pack" id="afp-pack" role="button" tabindex="0" aria-label="Open a booster pack">'+
            '<img id="afp-pack-img" alt="Astral Forge booster pack"/><span class="afp-rip">Tap to rip</span>'+
          '</div><div class="afp-status" id="afp-status"></div>'+
        '</div>';
      packImg=byId('afp-pack-img'); packBtn=byId('afp-pack'); statusEl=byId('afp-status');
      packImg.src=PACK_IMG;
      bindPack(); refreshStatus();
    }

    function doOpen(){
      if(!canOpen()){ if(load(K_BONUS,false)!==true) openModal(); return; }
      consumeOpen();
      packBtn.classList.add('afp-ripping');
      setTimeout(function(){ reveal(genPack()); },420);
    }
    function bindPack(){
      packBtn.addEventListener('click',doOpen);
      packBtn.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();doOpen();} });
    }

    /* unlock modal */
    function openModal(){ if(load(K_BONUS,false)===true) return; modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); }
    function closeModal(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); }
    byId('afp-modal-x').addEventListener('click',closeModal);
    modal.addEventListener('click',function(e){ if(e.target===modal) closeModal(); });

    /* init (also re-run when tab opened) */
    var inited=false;
    window.__afpInit=function(){
      if(inited){ refreshStatus(); return; }
      inited=true;
      bindPack(); renderColl(); seedFeed(); refreshStatus();
      /* bonus granted on customer-form reload */
      if(window.__afpGrantBonus===true && load(K_BONUS,false)!==true){
        setTimeout(function(){ if(statusEl) statusEl.innerHTML='<span class="afp-ready">✦ Bonus pack unlocked — tap to rip!</span>'; },300);
      }
    };
    window.__afpInit();
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
